const locale = require('./collaborationAttachment.i18n.json');

/*@ngInject*/
const CollaborationAttachmentController = function ($scope, $timeout, $uibModal, $window,
                                                    collaborationMediator, submissionUtil,
                                                    coreConstant, coreMediator, authorizationConstants, dateUtil,
                                                    attachmentUtil, preferenceModel, currentSubmissionModel, loadingBarHandler,
                                                    modalUtil, attachmentMediator, submissionConstant, collaborationUtil, emailMessage) {


    $scope.i18n = locale;

    function resetAttachmentViewModel() {
        $scope.attachmentViewModel = {
            attachment: {},
            uploadedFile: null,
            typeDataItems: [],
            modifyPermission: null,
            deletePermission: null,
            sharePermission: null,
            unacceptedTypes: preferenceModel.get('system.allowedFileTypes').split('::'),
            chooseFileString: $scope.i18n.chooseFile,
            pleaseChooseString: $scope.i18n.type,
            fileDescPlaceholder: $scope.i18n.fileDescription,
            nameEditMode: false,
            editNameIconText: $scope.i18n.editFilename,
            editableName: null,
            originalFileExtension: null,
            email:null
        };

        loadDataSets();
    }

    function retrieveAttachment(attachmentId) {
        resetAttachmentViewModel();
        $scope.viewModel.isLoading = true;
        attachmentMediator.retrieveAttachment(attachmentId).then(function (attachment) {
            $scope.viewModel.isLoading = false;
            $scope.attachmentViewModel.attachment = attachment.Attachment;
            $scope.attachmentViewModel.modifyPermission = attachment[authorizationConstants.AUTHORIZATION_MODIFY_ATTACHMENTS];
            $scope.attachmentViewModel.deletePermission = attachment[authorizationConstants.AUTHORIZATION_DELETE_ATTACHMENTS];
            $scope.attachmentViewModel.sharePermission = attachment[authorizationConstants.AUTHORIZATION_SHARE_ATTACHMENTS];
            $scope.attachmentViewModel.editableName = getEditableName($scope.attachmentViewModel.attachment.name);
            $scope.viewModel.attachment.isVisible = true;

            if ($scope.attachmentViewModel.attachment.attachedToEmail) {
                attachmentMediator.retrieveAttachmentEmails(attachmentId).then(function (emails) {
                    $scope.attachmentViewModel.emails = emails;
                });
            }

            loadDataSets();
        });
    }

    function loadDataSets() {
        attachmentUtil.getAttachmentTypes().then(function (result) {
            let attachment = $scope.attachmentViewModel.attachment || {},
                attachmentType = attachment.type || {};

            $scope.attachmentViewModel.typeDataItems = result;
            $scope.attachmentViewModel.selectedAttachmentType = _.find(result, {name: attachmentType});
        });
    }

    function storeUploadedFile(uploadedFile) {
        const allowFile = attachmentUtil.validateAttachment(uploadedFile, _.get($scope.i18n, 'unacceptableTypeAndSize'));
        if (allowFile) {
            $timeout(function () {
                $scope.attachmentViewModel.uploadedFile = uploadedFile;
                if (!$scope.attachmentViewModel.attachment) {
                    $scope.attachmentViewModel.attachment = {};
                }
                $scope.attachmentViewModel.attachment.name = uploadedFile.name;
                $scope.attachmentViewModel.attachment.size = uploadedFile.size;
                $scope.attachmentViewModel.attachment.name = uploadedFile.name;
                let fileSize = attachmentUtil.convertAttachmentSize(uploadedFile.size);
                $scope.attachmentViewModel.attachment.byteCountToDisplaySize = `(${fileSize})`;
                $scope.attachmentViewModel.editableName = getEditableName($scope.attachmentViewModel.attachment.name);
            }, 0);
        }
    }

    function getEditableName(attachmentName) {
        let fileNameParts = _.split(attachmentName, '.');
        if(fileNameParts.length > 1) {
            const fileExtension = _.last(fileNameParts);
            $scope.attachmentViewModel.originalFileExtension = fileExtension;
            return _.join(_.pull(fileNameParts, fileExtension), '.');
        }
        return attachmentName;
    }

    function appendOriginalFileExtension(attachmentName) {
        if(!_.isNil(attachmentName) && !_.isNil($scope.attachmentViewModel.originalFileExtension)) {
            return _.join([attachmentName, $scope.attachmentViewModel.originalFileExtension], '.');
        }
        return attachmentName;
    }

    $scope.attachmentTypePlaceholder = $scope.i18n.type;

    $scope.isEditable = function () {
        return !($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) ||
            ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id && $scope.attachmentViewModel.modifyPermission);
    };

    $scope.isCurrentUser = function () {
        return $scope.attachmentViewModel && $scope.attachmentViewModel.attachment &&
            $scope.viewModel.currentUserId === $scope.attachmentViewModel.attachment.createdBy.id;
    };

    $scope.getTitle = function () {
        if ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) {
            return $scope.i18n.viewFile;
        } else {
            return $scope.i18n.addFile;
        }
    };

    $scope.getAttachmentUserName = function () {
        let username = $scope.attachmentViewModel.attachment.createdBy.name;
        if ($scope.attachmentViewModel.attachment.createdBy.name === 'AUTHENTICATION_SERVER') {
            username = 'System';
        }
        return username;
    };

    $scope.attachmentDownloadClick = function () {
        let attachment = $scope.attachmentViewModel.attachment;
        if (!_.isNil(attachment.id)) {
            attachmentUtil.getAttachmentLinkURL(attachment.id, attachment.name).then((url) => {
                $window.open(url, '_blank');
            });
        }
    };

    $scope.$watch('viewModel.selectedItem', function (newItem) {
        if (newItem && newItem.type === 'attachment' && newItem.id) {
            retrieveAttachment(newItem.id);
        }
    });

    $scope.$watch('viewModel.attachment.isEditorOpen', function (isEditorOpen) {
        if (isEditorOpen) {
            $scope.viewModel.selectedItem = {type: 'attachment'};
        }
    });

    $scope.$watch('viewModel.attachment.isVisible', function (newItem) {
        if (!newItem && $scope.attachmentViewModel.attachment) {
            resetAttachmentViewModel();
        }
    });

    $scope.fileSelected = function (file) {
        if (file) {
            storeUploadedFile(file);
        }
    };

    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
        if (file) {
            storeUploadedFile(file);
        }
    });

    $scope.$on(submissionConstant.event.ATTACHMENT_EDITOR_DID_OPEN, function () {
        $scope.attachmentViewModel.attachment.shared = preferenceModel.get('system.shareAttachmentDefault') === 'true' ? true : false;
    });

    $scope.onCancelClick = function () {
        $scope.closeAttachmentEditor();
        resetAttachmentViewModel();
    };

    $scope.onUpdateField = function () {
        if(_.isEmpty($scope.attachmentViewModel.editableName)) {
            $scope.attachmentViewModel.editableName = getEditableName($scope.attachmentViewModel.attachment.name);
        } else {
            $scope.attachmentViewModel.attachment.name = appendOriginalFileExtension($scope.attachmentViewModel.editableName);
        }

        if ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) {
            $scope.updateAttachment($scope.attachmentViewModel.attachment);
        }
        $scope.attachmentViewModel.nameEditMode = false;
    };

    $scope.onUpdateSelectedType = function () {
        let attachment = $scope.attachmentViewModel.attachment;

        if ($scope.attachmentViewModel.selectedAttachmentType) {
            attachment.type = $scope.attachmentViewModel.selectedAttachmentType.name;
        } else {
            attachment.type = '';
        }

        // Only update the attachment if it exists, otherwise the type will be saved on upload.
        if (!_.isNil(attachment.id)) {
            $scope.updateAttachment(attachment);
        }
    };

    $scope.getEmailLabel = function (email) {
        return $scope.i18n.email + ' ' + dateUtil.formatShortDateAndTime(email.sentDate);
    };

    $scope.openEmail = function (email) {
        $scope.attachmentViewModel.email = email;
        $scope.setToOrCcUsers(email, 'to');
        $scope.setToOrCcUsers(email, 'cc');
        modalUtil.showEmailViewer( $scope.attachmentViewModel.email, $scope.forwardEmail, $scope.replyEmail, $scope.replyAllEmail);
    };

    $scope.setToOrCcUsers = function (email, type) {
        let userArray = _.split((type === 'to') ? email.to : email.cc, emailMessage.EMAIL_ADDRESS_SEPERATOR),
            recipientList = [];
        coreMediator.loadUsersList(email.submissionId).then(function (users) {
            _.each(userArray, function (toUser) {
                let addedUser = false;
                _.each(users, function (user) {
                    let userString = collaborationUtil.getEmailIdentifierString(user.name, user.emailAddress);
                    if (toUser === userString) {
                        recipientList.push(user);
                        addedUser = true;
                    }
                });
                if (!addedUser) {
                    recipientList.push(toUser);
                }

            });
            if (type === 'to') {
                $scope.attachmentViewModel.email.toUsers = recipientList;
            } else {
                $scope.attachmentViewModel.email.ccUsers = recipientList;
            }
        });
    };

    $scope.replyEmail = function (emailId) {
        loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
        $scope.newEmailId = emailId;
        collaborationMediator.replyEmail(emailId);
    };

    $scope.replyAllEmail = function (emailId) {
        loadingBarHandler.showLoadingBar('submission.collaboration.email.replyingToEmail');
        $scope.newEmailId = emailId;
        collaborationMediator.replyAllEmail(emailId);
    };

    $scope.forwardEmail = function (emailId) {
        loadingBarHandler.showLoadingBar('submission.collaboration.email.creatingForward');
        $scope.newEmailId = emailId;
        collaborationMediator.forwardEmail(emailId);
    };

    $scope.$on(submissionConstant.event.CREATE_COLLABORATION_ITEM_MESSAGE, function (event, payload) {
        if (payload.type === 'email' && $scope.newEmailId) {
            $timeout(function () {
                let submissionId = currentSubmissionModel.getCurrentSubmission().id;
                loadingBarHandler.hideLoadingBar();
                $scope.$emit(coreConstant.event.SHOW_EMAIL_EDITOR,
                             payload.id,
                             submissionId,
                             /*chatMessageId*/undefined,
                             /*emailMessageId*/undefined,
                             /*notificationId*/undefined,
                             /*deleteNewEmailOnCancel*/true,
                             /*isReplyOrForward*/true);
                $scope.newEmail = null;
            }, 50);
        }
    });

    $scope.onSave = function () {
        let submissionId = currentSubmissionModel.getCurrentSubmission().id,
            payload = attachmentUtil.getAttachmentPayload($scope.attachmentViewModel.attachment);

        payload = _.assign(payload, {
            'ownerUri': 'com.firstbest.underwriting.submission.Submission:' + submissionId,
            'submissionId': submissionId
        });

        $scope.saveAttachment(payload, $scope.attachmentViewModel.uploadedFile);
    };

    $scope.onDeleteClick = function () {

        let options = {
            title: $scope.i18n.deleteAttachmentTitle,
            summary: $scope.i18n.deleteAttachmentConfirmationMessage,
            cancelButtonLabel: $scope.i18n.cancelActionButtonLabel,
            confirmActionButtonLabel: $scope.i18n.confirmActionButtonLabel
        };

        let modalInstance = $uibModal.open({
            templateUrl: '/ui/modal/modal.tpl.html',
            controller: 'modalController',
            windowClass: 'genericModal',
            backdrop: 'static',
            resolve: {
                options: function () {
                    return options;
                }
            }
        });

        function handleClose() {
            deleteAttachment();
        }

        modalInstance.result.then(handleClose);

        function deleteAttachment() {
            if ($scope.attachmentViewModel.attachment && $scope.attachmentViewModel.attachment.id) {
                $scope.deleteAttachment($scope.attachmentViewModel.attachment.id);
            }
        }
    };

    $scope.activateEditFilename = function () {
        $scope.attachmentViewModel.nameEditMode = true;
    };

    resetAttachmentViewModel();
};

angular.module('gw-um-submission')
    .controller('collaborationAttachmentController', CollaborationAttachmentController);
